var React = require('react');

function FoundationsIcon (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"75","height":"75","rx":"12","fill":"#E8F1FB","key":0}),React.createElement("rect",{"x":"12.5","y":"12.5","width":"21.875","height":"21.875","fill":"#114E8B","key":1}),React.createElement("path",{"d":"M34.034 61.8749H29.3663L27.5108 57.0478H19.0163L17.2623 61.8749H12.7106L20.9877 40.624H25.5249L34.034 61.8749ZM26.1337 53.4673L23.2056 45.5816L20.3354 53.4673H26.1337Z","fill":"#1669BA","key":2}),React.createElement("rect",{"x":"40.625","y":"12.5","width":"21.875","height":"21.875","rx":"10.9375","fill":"#1976D2","key":3}),React.createElement("rect",{"x":"40.625","y":"40.625","width":"21.875","height":"21.875","fill":"white","key":4})]);
}

FoundationsIcon.defaultProps = {"width":"75","height":"75","viewBox":"0 0 75 75","fill":"none"};

module.exports = FoundationsIcon;

FoundationsIcon.default = FoundationsIcon;
